import { DME, DMEData } from "dmeditor";
import { nanoid } from "nanoid";
import { EntityResult } from "./entity";
const definition: DME.Widget = {
  category: "bridge",
  icon: "bridge",
  name: "Tournament result",
  type: "bridge-result",
  events: {
    createBlock: (): DMEData.Block<EntityResult> => {
      return {
        id: nanoid(),
        type: "bridge-result",
        data: {},
      };
    },
    updateData: () => {},
  },
  settings: [],
};

export default definition;
